export const FETCH_PAYMENT_TOKEN = 'FETCH_PAYMENT_TOKEN';
export const FETCH_PAYMENT_TOKEN_SUCCESS = 'FETCH_PAYMENT_TOKEN_SUCCESS';
export const FETCH_PAYMENT_TOKEN_FAILS = 'FETCH_PAYMENT_TOKEN_FAILS';

export const PAYMENT_SUBMIT = 'PAYMENT_SUBMIT';
export const PAYMENT_SUBMIT_SUCCESS = 'PAYMENT_SUBMIT_SUCCESS';
export const PAYMENT_SUBMIT_FAILS = 'PAYMENT_SUBMIT_FAILS';

export const PAYMENT_TYPE_SUCCESS = 'PAYMENT_TYPE_SUCCESS';